import { useState, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Nav,
  NavItem,
  Row,
  NavLink,
  TabContent,
  TabPane,
  CardImg,
  CardText,
  CardLink,
  Button,
  InputGroup,
  Form,
  InputGroupText,
  InputGroupAddon,
  Input,
} from "reactstrap";
import { isMobile } from "react-device-detect";
import MarketPriceTable from "components/table/marketPriceTable";
import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import { selectpriceTokens } from "store/selector/bestPriceCoins";
import { getTokenInfo, getTokensItem } from "utils/getters";
import { selectToken } from "store/selector/tokenStore";
import { LIVE_PRICE_COLUMNS_ALL_COIN } from "constants/tableColumns";
import TokenPriceState from "components/pages/web/static/tokenPriceState";
import HeatMap from "components/pages/web/static/heatMap.jsx";
import { getQsByKey } from "utils/Format";
import blog from "assets/image/blog.png";
import cn from "classnames";
import ChartDown from "assets/image/chart-arrow.png";
import Graph from "assets/image/graph.png";
import ChartUp from "assets/image/chart-arrow-up.png";
import LottieLogo from "components/pages/lottie";
import { logoOptions } from "constants/lotties";
import "assets/styles/components/form.scss";
import market from "assets/image/market-logo.png";
import { COINNIK_MARKET_BLOG } from "configs/constants";

const ShowAllMarkets = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<any>("toman-tab");
  const [searchInput, setSearchInput] = useState<any>("");
  const [filterTether, setFilterTether] = useState<any>([]);
  const [filterToman, setFilterToman] = useState<any>([]);

  const currentPair = getQsByKey().get("side");
  const TomanMarket: any = getTokensItem("TMN");
  const TetherMarket: any = getTokensItem("USDT");
  const stateList = useSelector(selectpriceTokens);
  const { tokenList, allTomanMarket } = stateList;
  const { allTokens } = useSelector(selectToken);

  const columns = LIVE_PRICE_COLUMNS_ALL_COIN;
  const tetherFilter = filterTether.length ? filterTether : TetherMarket;
  const tomanFilter = filterToman.length ? filterToman : TomanMarket;

  useEffect(() => {
    switch (currentPair) {
      case "USDT":
        setActiveTab("tether-tab");
        break;
      case "TMN":
        setActiveTab("toman-tab");
        break;
      default:
        setActiveTab("toman-tab");
    }
    // dispatch(tokens());
  }, [currentPair]);

  const handleChange = (txt: any) => {
    let tetherFilterd = TetherMarket.filter((item: any) => {
      return t(item.localeName).indexOf(txt.target.value) >= 0;
    });
    let tomanFilterd = TomanMarket.filter((item: any) => {
      return t(item.localeName).indexOf(txt.target.value) >= 0;
    });
    setFilterToman(tomanFilterd);
    setFilterTether(tetherFilterd);
    setSearchInput(txt.target.value);
  };

  let changeMax = Math.max(
    ...allTomanMarket.map((x: any) => x.change24Percentage)
  );
  let changeMin = Math.min(
    ...allTomanMarket.map((x: any) => x.change24Percentage)
  );
  let ChangeMaxObject = allTomanMarket.find(
    (value: any) => value.change24Percentage == changeMax
  );
  let ChangeMixObject = allTomanMarket.find(
    (value: any) => value.change24Percentage == changeMin
  );
  let tradeMax = Math.max(...allTomanMarket.map((x: any) => x.vol24Base));
  let tradeObject = allTomanMarket.find(
    (value: any) => value.vol24Base == tradeMax
  );

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const coinArray = [
    {
      id: 1,
      title: t("Maximum daily trading volume"),
      img: Graph,
      coinName: tradeObject
        ? getTokenInfo(tradeObject.pair.split("/")[0]).localeName
        : null,
      price: tradeObject ? tradeObject.bestBuy : null,
      change: tradeObject ? tradeObject.change24Percentage : null,
      icon: tradeObject
        ? getTokenInfo(tradeObject.pair.split("/")[0]).logoUrl64px
        : null,
    },
    {
      id: 1,
      img: ChartUp,
      title: t("The largest daily price increase"),
      coinName: ChangeMaxObject
        ? getTokenInfo(ChangeMaxObject.pair.split("/")[0]).localeName
        : null,
      price: ChangeMaxObject ? ChangeMaxObject.bestBuy : null,
      change: ChangeMaxObject ? ChangeMaxObject.change24Percentage : null,
      icon: ChangeMaxObject
        ? getTokenInfo(ChangeMaxObject.pair.split("/")[0]).logoUrl64px
        : null,
    },
    {
      id: 1,
      img: ChartDown,
      title: t("The largest daily price reduction"),
      coinName: ChangeMixObject
        ? getTokenInfo(ChangeMixObject.pair.split("/")[0]).localeName
        : null,
      price: ChangeMixObject ? ChangeMixObject.bestSell : null,
      change: ChangeMixObject ? ChangeMixObject.change24Percentage : null,
      icon: ChangeMixObject
        ? getTokenInfo(ChangeMixObject.pair.split("/")[0]).logoUrl64px
        : null,
    },
  ];

  // if (isLoading) {
  //   return <span>{t("please wait...")}</span>;
  // }

  return (
    <>
      <StaticHeaderInfo>
        <Row className="d-flex flex-row-reverse pb-5">
          <Col xs={{ order: 2 }} sm="12" md="8" lg="8">
            <span className="fw-bold text-light fs-2 ">
              {t("Instant price of digital currencies in Kevin Nick Market")}{" "}
            </span>
          </Col>
          <Col
            xs={{ order: 1 }}
            sm="12"
            md="4"
            lg="4"
            className="d-flex justify-content-end"
          >
            <div className="view-btn">
              <Button
                size="md"
                color="warning"
                outline
                className="text-light "
                href="#down"
              >
                <img src={market} alt="image" className="ms-3" />
                {t("Market at a glance")}
              </Button>
            </div>
          </Col>
        </Row>
      </StaticHeaderInfo>
      <Container>
        {tokenList.length && allTokens.length ? (
          <>
            <Row className="mt-n5 mb-0 mb-md-0">
              {coinArray.map((item) => (
                <Col
                  xs="12"
                  sm="12"
                  md="12"
                  lg="6"
                  xl="4"
                  className="mb-3 mb-xl-0"
                >
                  <Card className=" shadow border-radius-1 pt-4 pb-3">
                    <CardTitle className="fs-7 ">
                      <img src={item.img} className=" px-3" />
                      <span className="text-secondary-seven-light fw-Medium">
                        {item.title}
                      </span>
                    </CardTitle>
                    <CardBody className="none-padding ">
                      <div className="box box-md box-md-gray">
                        <div className="d-flex align-items-center justify-content-between px-3 box-padding-tb">
                          <img
                            src={item.icon}
                            className="coin-logo"
                            alt="picture not find"
                          />
                          <span className="fs-6 text-secondary-seven-light ">
                            {item.coinName}
                          </span>
                          <span className="fs-6 text-secondary-seven-light px-1">
                            {Number(item.price)}
                          </span>
                          <span className="fs-8 text-secondary-three-light">
                            {t("Toman")}
                          </span>
                          <TokenPriceState
                            value={item.change}
                            indicatorType="background"
                          />
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <Row className="pb-3 pt-3  ">
              <Col xs="12">
                <Card className="shadow border-radius-1 none-padding">
                  <CardBody className="fs-6 none-padding ">
                    <Row className="pt-sm-2">
                      <Col xs="12" md="6">
                        <CardTitle className="style-nav-tab nav d-flex justify-content-between align-items-center  mx-3 mx-md-0">
                          <Nav
                            tabs
                            className="border-radius-tl-1 border-radius-tr-1 none-border-bottom none-padding"
                          >
                            <span className="d-flex align-items-center table-font-mobile text-secondary-one-light  ">
                              {t("select:")}
                            </span>
                            <div className="d-flex box box-md box-md-gray py-1 my-2 px-1 me-4 ">
                              <NavItem
                                className={
                                  activeTab === "toman-tab" ? "nav-active" : ""
                                }
                              >
                                <NavLink
                                  className={cn(
                                    "fw-Medium px-3 text-secondary-one-light nav-link--padding table-font-mobile",
                                    {
                                      active: activeTab === "toman-tab",
                                    }
                                  )}
                                  onClick={() => {
                                    toggleTab("toman-tab");
                                  }}
                                >
                                  {t("Toman Markets")}
                                </NavLink>
                              </NavItem>
                              <NavItem
                                className={
                                  activeTab === "tether-tab" ? "nav-active" : ""
                                }
                              >
                                <NavLink
                                  className={cn(
                                    "fw-Medium px-3 text-secondary-one-light nav-link--padding table-font-mobile",
                                    {
                                      active: activeTab === "tether-tab",
                                    }
                                  )}
                                  onClick={() => {
                                    toggleTab("tether-tab");
                                  }}
                                >
                                  {t("Tether Markets")}
                                </NavLink>
                              </NavItem>
                            </div>
                          </Nav>
                        </CardTitle>
                      </Col>
                      <Col xs="12" md="6">
                        <div className="d-md-flex  mx-2 align-items-center  justify-content-end pt-2">
                          <Form className="form-style ">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText className="border-radius-tr-1 border-radius-br-1">
                                  <i className="icon-search" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                type="text"
                                value={searchInput}
                                onChange={(txt: any) => handleChange(txt)}
                                placeholder={t("Search the Market")}
                                className="fs-6 py-3 fs-sm text-secondary-nine-light border-radius-tl-1 border-radius-bl-1 "
                              />
                            </InputGroup>
                          </Form>
                        </div>
                      </Col>
                    </Row>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId={"toman-tab"}>
                        <Row>
                          <Col sm="12">
                            <MarketPriceTable
                              columns={columns}
                              data={
                                tomanFilter.length ? tomanFilter : TomanMarket
                              }
                              tomanLength={TomanMarket.length}
                            />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId={"tether-tab"}>
                        <Row>
                          <Col sm="12">
                            <MarketPriceTable
                              columns={columns}
                              data={
                                tetherFilter.length
                                  ? tetherFilter
                                  : TetherMarket
                              }
                              tetherLength={TetherMarket.length}
                            />
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row id="down">
              <Col xs="12">
                <Card className="shadow border-radius-1 ">
                  <HeatMap></HeatMap>
                </Card>
              </Col>
            </Row>
            <Row className="pt-5 ">
              <Col xs="12">
                <Card className="text-light shadow bg-primary-one border-radius-1">
                  <CardBody>
                    <Row>
                      <Col
                        xs="12"
                        md="12"
                        xl="9"
                        lg="9"
                        className="mb-3 mb-md-0"
                      >
                        <CardTitle className="fs-5 text-light">
                          {" "}
                          <Trans i18nKey="our_blog">
                            Everything you need to start a deal is on our blog
                            <span className="text-warning-light"> blog</span>
                          </Trans>
                        </CardTitle>
                        <CardText className="fs-6 text-light">
                          <Trans i18nKey="daily_analysis">
                            You can follow the{" "}
                            <span className="text-warning-light">
                              {" "}
                              daily analysis
                            </span>{" "}
                            of digital currencies,
                            <span className="text-warning-light">
                              {" "}
                              weekly analysis
                            </span>{" "}
                            of digital currencies, technical analysis training
                            <span className="text-warning-light">
                              technical analysis training
                            </span>
                            , familiarity with digital currencies and news in
                            this field in our blog to get enough information for
                            trading.
                          </Trans>
                        </CardText>
                        <CardLink className="d-none d-sx-block d-sm-block ">
                          <a href={COINNIK_MARKET_BLOG}>
                            <Button
                              size="lg"
                              color="warning"
                              className="text-light"
                            >
                              {t("View the blog")}
                            </Button>
                          </a>
                        </CardLink>
                      </Col>
                      <Col xs="5" className="d-block d-sm-none">
                        <a href={COINNIK_MARKET_BLOG}>
                          <Button
                            size="lg"
                            color="warning"
                            className="text-light"
                          >
                            {t("Blog")}
                          </Button>
                        </a>
                      </Col>
                      <Col
                        xs="7"
                        md="8"
                        xl="3"
                        lg="3"
                        className="d-flex justify-content-end justify-content-sm-start align-items-start"
                      >
                        <CardImg src={blog} className="mt-n4 mb-n4 m-ms-0" />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        ) : (
          <LottieLogo options={logoOptions} />
        )}
      </Container>
    </>
  );
};
export default ShowAllMarkets;
